export default __webpack_public_path__ + "static/media/Web_01-01.764e3339.png";